import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import LandingPage from "./pages/LandingPage";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import MasterplanPage from "./pages/MasterplanPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import InvestmentPage from "./pages/InvestmentPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Landing page without header/footer */}
          <Route path="/" element={<LandingPage />} />
          
          {/* Main site with header/footer */}
          <Route path="/*" element={
            <>
              <Header />
              <main>
                <Routes>
                  <Route path="/home" element={<HomePage />} />
                  <Route path="/services" element={<ServicesPage />} />
                  <Route path="/masterplan" element={<MasterplanPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/investment" element={<InvestmentPage />} />
                </Routes>
              </main>
              <Footer />
            </>
          } />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;